module.exports = __webpack_public_path__ + "static/media/artificial-intelligence.8827960e.png";